import { render, staticRenderFns } from "./formgroupWYSIWYG.vue?vue&type=template&id=d882c718&"
import script from "./formgroupWYSIWYG.vue?vue&type=script&lang=js&"
export * from "./formgroupWYSIWYG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports